import React, { useMemo } from "react";
import { useBetSlip } from "../providers/BetSlipProvider";
import { BetSlipMode } from "../types/enums";
import { useI18n } from "../providers/I18nProvider";

export const Header: React.FC = () => {
  const { betSlipState, onChangeMode } = useBetSlip();
  const { t } = useI18n();

  const handleModeChange = (newMode: BetSlipMode) => {
    onChangeMode(newMode);
  };

  const isSingleDisabled = useMemo(() => {
    return (
      betSlipState.betBuilderState.bets.length > 0 &&
      betSlipState.selections.length === 0
    );
  }, [betSlipState.betBuilderState, betSlipState.selections]);

  return (
    <div className="w-full">
      {/* Mode Tabs */}
      <div className="flex bg-betslip-header-bg pb-1">
        {[
          t(BetSlipMode.Single as any),
          ...(betSlipState.selections.length > 1 ||
          betSlipState.betBuilderState.bets.length > 0
            ? [t(BetSlipMode.Combo as any)]
            : []),
        ].map((item) => (
          <button
            key={item}
            onClick={() => handleModeChange(item as BetSlipMode)}
            disabled={item === BetSlipMode.Single && isSingleDisabled}
            className={`flex-1 pt-2 pb-1 text-md ${
              betSlipState.mode === item
                ? "text-betslip-header-text border-b-3 border-betslip-header-border font-bold"
                : "text-body-text"
            }`}
          >
            {item.charAt(0).toUpperCase() + item.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Header;
